// extracted by mini-css-extract-plugin
export default {"table":"TopSection_table__7ZkfV"};